import Api from '../../utils/api'

export const sortFolders = (a: string, b: string, columnSort: ColumnSortType) => (columnSort.name === 'asc' ? a.localeCompare(b) : b.localeCompare(a))

export const treeList = (root: number, folderTree: IFolderTree, columnSort: ColumnSortType, priority: AccountsColumnsType[]): number[] =>
  folderTree[root] && folderTree[root].children
    ? (folderTree[root].children ?? []).sort((a: number, b: number) => {
        const folderAData = folderTree[a].data
        const folderBData = folderTree[b].data
        if (folderAData && folderBData) {
          const firstDifference = priority.find((col) => folderAData[col] !== folderBData[col])
          if (!firstDifference) return 0
          const sortOrder = columnSort[firstDifference] === 'desc' ? -1 : 1
          if (firstDifference === 'name' || firstDifference === 'status')
            return folderAData[firstDifference].localeCompare(folderBData[firstDifference]) * sortOrder
          return folderAData[firstDifference] > folderBData[firstDifference] ? sortOrder : -sortOrder
        }
        return sortFolders(folderTree[a].name, folderTree[b].name, columnSort)
      })
    : []

export const getFolderAlerts = async (folderId: string, accessToken: string, host: string, signal?: AbortSignal): Promise<IFolderAlertExtended[]> => {
  const apiAlerts: IFolderAlert[] = []
  let apiDevices: {
    [x: string]: {
      deviceLocation: string
      deviceName: string
      tags: string[]
    }
  } = {}
  let apiRules: {
    [x: string]: {
      channel: string
      channelType: string
      ruleName: string
      tags: string[]
    }
  } = {}
  let apiUsers: {
    [x: string]: {
      firstName: string
      lastName: string
      notifyPrefs: string[]
    }
  } = {}

  const getFolderAlertsApi = async (offset?: string): Promise<IFolderAlertExtended[]> => {
    const response = await Api.get(
      offset ? `${host}/api/v2/central/folders/${folderId}/alerts?offset=${offset}` : `${host}/api/v2/central/folders/${folderId}/alerts`,
      {
        signal,
      }
    )
    if (!response.ok) throw new Error('Could not get folder alerts')

    const { alerts, devices, rules, users } = response.body

    apiAlerts.push(...alerts)
    apiDevices = { ...apiDevices, ...devices }
    apiRules = { ...apiRules, ...rules }
    apiUsers = { ...apiUsers, ...users }

    if (response.body.hasMore) {
      // Call the function again (recursively continue to fetch devices until hasMore is false)
      return getFolderAlertsApi(response.body.nextOffset)
    }

    // Return the data
    return apiAlerts.map((a: IFolderAlert) => ({
      ...a,
      deviceLocation: apiDevices[a.deviceId].deviceLocation,
      deviceName: apiDevices[a.deviceId].deviceName,
      ruleName: apiRules[a.ruleId].ruleName,
      channel: apiRules[a.ruleId].channel,
      channelType: apiRules[a.ruleId].channelType,
      responses: a.responses.map((r: { alarmTs: string; note: string; reactionType: string; updatedAt: string; updatedBy: number; user: number }) => ({
        ...r,
        alarmTs: r.alarmTs,
        note: r.note as AlertResponse,
        reactionType: r.reactionType,
        updatedAt: r.updatedAt,
        updatedBy: {
          id: r.updatedBy,
          firstName: apiUsers[r.updatedBy]?.firstName,
          lastName: apiUsers[r.updatedBy]?.lastName,
          notifyPrefs: apiUsers[r.updatedBy]?.notifyPrefs,
        },
        user: { id: r.user, firstName: apiUsers[r.user].firstName, lastName: apiUsers[r.user].lastName, notifyPrefs: apiUsers[r.user].notifyPrefs },
      })),
    }))
  }

  return getFolderAlertsApi()
}
